import React from 'react';
import {
  Redirect,
  useLocation,
} from 'react-router-dom';

// IMPORTING CSS
import 'assets/css/shared.css';

const ForgotPasswordPage = () => {
  const location = useLocation();

  const locationParams = new URLSearchParams(location.search);

  const hash = locationParams.get('hash');

  return (

    <Redirect
      to={{
        pathname: '/resetpassword',
        state: { hash },
      }}
    />

  );
};

export default ForgotPasswordPage;
